import { createSelector } from 'reselect';
import { GlobalState } from '@/redux/store';
import { HouseBillingHistorySlice } from '@/redux/modules/billingManagement/houseBillingHistory/houseBillingHistory.types';

const sliceSelector = (state: GlobalState): HouseBillingHistorySlice => state.houseBillingHistory;
const idSelector = (_: GlobalState, houseId: number) => houseId;
const isLoadingSelector = createSelector([sliceSelector, idSelector], (slice, houseId) =>
    slice.loading.includes(houseId)
);

export const getHouseBillingHistoryItems = createSelector(
    [sliceSelector, idSelector],
    (slice, houseId) => slice.byId[houseId] ?? []
);

export const shouldFetchHouseBillingHistory = createSelector(
    [getHouseBillingHistoryItems, isLoadingSelector],
    (historyItems, isLoading) => historyItems.length === 0 && !isLoading
);
